import moment from 'moment'

import { DATE_STORE_KEY_FORMAT } from '../../../Common/settings/dateFormats'
import { IBlock, ICalendarEvents, IDateRange } from '../../types'
import { getDaysBetweenDates } from '../../utils'

export const blockForCalendarTransformer = (
  blockArray: IBlock[],
  dateRange: IDateRange,
): ICalendarEvents => {
  const dateKeyArray: string[] = getDaysBetweenDates(
    dateRange.start,
    dateRange.end,
  )
  const events: ICalendarEvents['eventsByDay'] = dateKeyArray.reduce<{
    [key: number]: { appointments: []; blocks: [] }
  }>((acc, dateKey) => {
    const dayAppointments: IBlock[] = blockArray.filter(
      block => moment(block.startsAt).format(DATE_STORE_KEY_FORMAT) === dateKey,
    )
    return {
      ...acc,
      [dateKey]: { blocks: dayAppointments },
    }
  }, {})

  return {
    eventsByDay: events,
    openFormDetails: { type: 'idle', event: null },
    eventPositionChange: { uuid: null, state: 'idle' },
  }
}
